import { Component, Inject, Optional } from '@angular/core';
import { POPOVER_DATA } from '../util/popover-token';
import * as i0 from "@angular/core";
import * as i1 from "../util/popover-ref";
import * as i2 from "@angular/common";
function PopoverContentComponent_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "h2", 3);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const title_r1 = ctx.ngIf;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(title_r1);
} }
export class PopoverContentComponent {
    constructor(popoverRef, data) {
        this.popoverRef = popoverRef;
        this.data = data;
    }
    close() {
        this.popoverRef.close();
    }
}
PopoverContentComponent.ɵfac = function PopoverContentComponent_Factory(t) { return new (t || PopoverContentComponent)(i0.ɵɵdirectiveInject(i1.PopoverRef), i0.ɵɵdirectiveInject(POPOVER_DATA, 8)); };
PopoverContentComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PopoverContentComponent, selectors: [["mhe-popover-content"]], decls: 4, vars: 2, consts: [["aria-label", "close", 1, "btn", "btn-close", "btn-sm", 3, "click"], [4, "ngIf"], ["id", "popover-content", 3, "innerHTML"], ["id", "popover-title", 1, "popover-header"]], template: function PopoverContentComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div")(1, "button", 0);
        i0.ɵɵlistener("click", function PopoverContentComponent_Template_button_click_1_listener() { return ctx.close(); });
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(2, PopoverContentComponent_ng_container_2_Template, 3, 1, "ng-container", 1);
        i0.ɵɵelement(3, "div", 2);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.data == null ? null : ctx.data.title);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("innerHTML", ctx.data == null ? null : ctx.data.content, i0.ɵɵsanitizeHtml);
    } }, dependencies: [i2.NgIf], styles: ["[_nghost-%COMP%]{display:block;padding:1.75em}[_nghost-%COMP%]   .popover-header[_ngcontent-%COMP%]{margin-top:0}[_nghost-%COMP%]   .btn-close[_ngcontent-%COMP%]{position:absolute;top:.25em;right:.25em}\n"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PopoverContentComponent, [{
        type: Component,
        args: [{ selector: 'mhe-popover-content', template: "<div>\n  <!-- default close button -->\n  <button class=\"btn btn-close btn-sm\" aria-label=\"close\" (click)=\"close()\"></button>\n\n  <!-- title (optional) -->\n  <ng-container *ngIf=\"data?.title as title\">\n    <h2 id=\"popover-title\" class=\"popover-header\">{{ title }}</h2>\n  </ng-container>\n\n  <!-- content -->\n  <div id=\"popover-content\" [innerHTML]=\"data?.content\"></div>\n</div>\n", styles: [":host{display:block;padding:1.75em}:host .popover-header{margin-top:0}:host .btn-close{position:absolute;top:.25em;right:.25em}/*# sourceMappingURL=popover-content.component.css.map */\n"] }]
    }], function () { return [{ type: i1.PopoverRef }, { type: undefined, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [POPOVER_DATA]
            }] }]; }, null); })();
